import { render, staticRenderFns } from "./customsCommodityCode.vue?vue&type=template&id=55592baf&scoped=true"
import script from "./customsCommodityCode.vue?vue&type=script&lang=js"
export * from "./customsCommodityCode.vue?vue&type=script&lang=js"
import style0 from "./customsCommodityCode.vue?vue&type=style&index=0&id=55592baf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55592baf",
  null
  
)

export default component.exports